export class keyCloakConfig {

    private oAuthScope: string;
    private oAuthUrl: string;
    private oAuthClientId: string;
    private oAuthCodeChallengeMethod: string;
    private oAuthResponseType: string;
    private oAuthRedirectUrl: string;

    constructor() {}

    setAuthScope(AuthScope: string): void {
        this.oAuthScope = AuthScope;
    }
    getAuthScope(): string {
        return this.oAuthScope;
    }
    setAuthUrl(AuthUrl: string): void {
        this.oAuthUrl = AuthUrl;
    }
    getAuthUrl(): string {
        return this.oAuthUrl;
    }
    setAuthClientId(AuthClientId: string): void {
        this.oAuthClientId = AuthClientId;
    }
    getAuthClientId(): string {
        return this.oAuthClientId;
    }

    setAuthCodeChallengeMethod(AuthCodeChallengeMethod: string): void {
        this.oAuthCodeChallengeMethod = AuthCodeChallengeMethod;
    }
    getAuthCodeChallengeMethod(): string {
        return this.oAuthCodeChallengeMethod;
    }

    setAuthResponseType(AuthResponseType: string): void {
        this.oAuthResponseType = AuthResponseType;
    }
    getAuthResponseType(): string {
        return this.oAuthResponseType;
    }

    setAuthRedirectUrl(AuthRedirectUrl: string): void {
        this.oAuthRedirectUrl = AuthRedirectUrl;
    }
    getAuthRedirectUrl(): string {
        return this.oAuthRedirectUrl;
    }
}